var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74976 18H4.74975C3.64518 17.9999 2.74975 17.1045 2.74976 15.9999L2.74983 3.99999C2.74984 2.89542 3.64527 2 4.74983 2H13.7501C14.8546 2 15.7501 2.89543 15.7501 4V8M6.25007 6H12.2501M6.25007 9H12.2501M12.2501 12.9616V15.4153C12.2501 16.6278 13.5429 17.7398 14.7554 17.7398C15.9678 17.7398 17.2501 16.6278 17.2501 15.4153V12.3159C17.2501 11.674 16.8811 11.0226 16.0602 11.0226C15.1821 11.0226 14.7554 11.674 14.7554 12.3159V15.2861M6.25007 12H9.25007",
    stroke: "#0B7CE4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttach);
export default __webpack_public_path__ + "static/media/file-attach.23efe3f135844bd7caf12d814dc6d201.svg";
export { ForwardRef as ReactComponent };